import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'flamstop/calendar';

const fsCalendarService = {
  getCalendarDays: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default fsCalendarService;
